import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export const AlertIcon = (props) => {
  const { color } = props;

  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.8998 69.9998H65.0998C70.2331 69.9998 73.4331 64.4331 70.8664 59.9998L45.7664 16.6331C43.1997 12.1998 36.7998 12.1998 34.2331 16.6331L9.13309 59.9998C6.56642 64.4331 9.76642 69.9998 14.8998 69.9998ZM39.9998 46.6664C38.1664 46.6664 36.6664 45.1664 36.6664 43.3331V36.6664C36.6664 34.8331 38.1664 33.3331 39.9998 33.3331C41.8331 33.3331 43.3331 34.8331 43.3331 36.6664V43.3331C43.3331 45.1664 41.8331 46.6664 39.9998 46.6664ZM43.3331 59.9998H36.6664V53.3331H43.3331V59.9998Z" fill={color} />
    </svg>
  );
};
